import {
  ACTIVITY_DEFINITION_MAPPING,
  GENERIC_ACTIVITY_DEFINITIONS,
} from '@xt/verification-sdk';
import { IDENT_TYPES } from './identification-types';

export const GENERIC_IDENTIFICATION_STEP = {
  INITIATE_IDENTIFICATION: 'initiate-identification',
  SELECT_IDENTIFICATION_TYPE: 'select-identification-type',
  COLLECT_PATIENT_PERSONAL_MASTER_DATA: 'collect-patient-personal-master-data',
  COLLECT_REPRESENTED_PERSONAL_MASTER_DATA: 'collect-represented-personal-data',
  SELECT_ROLES: 'select_roles',
  GET_VERIFICATION_CODE: 'get-verification-code',
  COLLECT_PROVIDER_PERSONAL_MASTER_DATA:
    'collect-provider-personal-master-data',
  COLLECT_PROVIDER_MEDICAL_DATA: 'collect-provider-medical-data',
  COLLECT_REPRESENTATIVE_PERSONAL_MASTER_DATA:
    'collect-representative-personal-master-data',
  SUB_USER_DEMOGRAPHICS_IDENTIFICATION: 'sub_user_demographics_identification',
  SUB_PATIENT_IDENTIFICATION: 'sub_patient_identification',
  PROVIDER_SELECT_ORGANISATION: 'provider_select_organisation',
  PATIENT_SELECT_ORGANISATION: 'patient_select_organisation',
  REPRESENTATIVE_SELECT_ORGANISATION: 'representative_select_organisation',
};

export const INIT_IDENTIFICATION_STEP = {
  PRESELECT_IDENTIFICATION_TYPE: 'preselect-identification-type',
  SELECT_ACTIVATION_TYPE: 'select-activation-type',
  CONFIRM_CONSENT_AND_INIT: 'confirm-consent-and-init-initialisation',
};

export const GENERIC_VERIFICATION_STEP = {
  VERIFY_PATIENT_PERSON_DATA: 'verify-patient-person-data',
  VERIFY_REPRESENTATITIVE_PERSON_DATA: 'verify-representative-person-data',
  VERIFY_REPRESENTED_PERSON_DATA: 'verify-represented-person-data',
  VERIFY_PROVIDER_PERSON_DATA: 'verify-provider-person-data',
  VERIFY_ORGANIZATION: 'verify-organization',
  VERIFY_PROVIDER_ORGANIZATION: 'verify-provider-organization',
  VERIFY_ROLES: 'verify-roles',
  VERIFY_MEDICAL_DATA: 'verify-medical-data',
};

export const IDENTIFICATION_STEPS_MAPPING = {
  [GENERIC_ACTIVITY_DEFINITIONS.PersonData]: {
    [IDENT_TYPES.PATIENT]:
      GENERIC_IDENTIFICATION_STEP.COLLECT_PATIENT_PERSONAL_MASTER_DATA,
    [IDENT_TYPES.REPRESENTATIVE]:
      GENERIC_IDENTIFICATION_STEP.COLLECT_REPRESENTATIVE_PERSONAL_MASTER_DATA,
    [IDENT_TYPES.PERSON]:
      GENERIC_IDENTIFICATION_STEP.SUB_USER_DEMOGRAPHICS_IDENTIFICATION,
    [IDENT_TYPES.PROFESSIONAL]:
      GENERIC_IDENTIFICATION_STEP.COLLECT_PROVIDER_PERSONAL_MASTER_DATA,
  },
  [GENERIC_ACTIVITY_DEFINITIONS.RepresentedPersonData]: {
    [IDENT_TYPES.REPRESENTATIVE]:
      GENERIC_IDENTIFICATION_STEP.COLLECT_REPRESENTED_PERSONAL_MASTER_DATA,
  },
  [GENERIC_ACTIVITY_DEFINITIONS.OrgaSelection]: {
    [IDENT_TYPES.REPRESENTATIVE]:
      GENERIC_IDENTIFICATION_STEP.REPRESENTATIVE_SELECT_ORGANISATION,
    [IDENT_TYPES.PATIENT]:
      GENERIC_IDENTIFICATION_STEP.PATIENT_SELECT_ORGANISATION,
    [IDENT_TYPES.PROFESSIONAL]:
      GENERIC_IDENTIFICATION_STEP.PROVIDER_SELECT_ORGANISATION,
  },
  [GENERIC_ACTIVITY_DEFINITIONS.PersonDataVerification]: {
    [IDENT_TYPES.PATIENT]: GENERIC_IDENTIFICATION_STEP.GET_VERIFICATION_CODE,
    [IDENT_TYPES.REPRESENTATIVE]:
      GENERIC_IDENTIFICATION_STEP.GET_VERIFICATION_CODE,
    [IDENT_TYPES.PERSON]: GENERIC_IDENTIFICATION_STEP.GET_VERIFICATION_CODE,
    [IDENT_TYPES.PROFESSIONAL]:
      GENERIC_IDENTIFICATION_STEP.GET_VERIFICATION_CODE,
  },
  [GENERIC_ACTIVITY_DEFINITIONS.RolesSelection]: {
    [IDENT_TYPES.PROFESSIONAL]: GENERIC_IDENTIFICATION_STEP.SELECT_ROLES,
  },
  [GENERIC_ACTIVITY_DEFINITIONS.ProviderMedicalData]: {
    [IDENT_TYPES.PROFESSIONAL]:
      GENERIC_IDENTIFICATION_STEP.COLLECT_PROVIDER_MEDICAL_DATA,
  },
};

export const VERIFICATION_STEPS_MAPPING = {
  [GENERIC_ACTIVITY_DEFINITIONS.PersonDataVerification]: {
    [IDENT_TYPES.PATIENT]: GENERIC_VERIFICATION_STEP.VERIFY_PATIENT_PERSON_DATA,
    [IDENT_TYPES.REPRESENTATIVE]:
      GENERIC_VERIFICATION_STEP.VERIFY_REPRESENTATITIVE_PERSON_DATA,
    [IDENT_TYPES.PERSON]:
      GENERIC_VERIFICATION_STEP.VERIFY_REPRESENTATITIVE_PERSON_DATA,
    [IDENT_TYPES.PROFESSIONAL]:
      GENERIC_VERIFICATION_STEP.VERIFY_PROVIDER_PERSON_DATA,
  },
  [GENERIC_ACTIVITY_DEFINITIONS.RepresentedPersonDataVerification]: {
    [IDENT_TYPES.REPRESENTATIVE]:
      GENERIC_VERIFICATION_STEP.VERIFY_REPRESENTED_PERSON_DATA,
  },
  [GENERIC_ACTIVITY_DEFINITIONS.OrganizationVerification]: {
    [IDENT_TYPES.REPRESENTATIVE]: GENERIC_VERIFICATION_STEP.VERIFY_ORGANIZATION,
    [IDENT_TYPES.PATIENT]: GENERIC_VERIFICATION_STEP.VERIFY_ORGANIZATION,
    [IDENT_TYPES.PROFESSIONAL]:
      GENERIC_VERIFICATION_STEP.VERIFY_PROVIDER_ORGANIZATION,
  },
  [GENERIC_ACTIVITY_DEFINITIONS.RoleVerification]: {
    [IDENT_TYPES.PROFESSIONAL]: GENERIC_VERIFICATION_STEP.VERIFY_ROLES,
  },
  [GENERIC_ACTIVITY_DEFINITIONS.MedicalDataVerification]: {
    [IDENT_TYPES.PROFESSIONAL]: GENERIC_VERIFICATION_STEP.VERIFY_MEDICAL_DATA,
  },
};

export const IDENTIFICATION_STEPS_CONFIG = {
  genericIdentificationSteps: GENERIC_IDENTIFICATION_STEP,
  identificationStepsMapping: IDENTIFICATION_STEPS_MAPPING,
  verificationStepsMapping: VERIFICATION_STEPS_MAPPING,
  ACTIVITY_DEFINITION_MAPPING,
};
